
      const form = document.getElementById('upload-form');
      const submitBtn = document.getElementById('submit-btn');
      const resultEl = document.getElementById('result');
      const statsEl = document.getElementById('stats');

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        submitBtn.disabled = true;
        submitBtn.textContent = '解析中...';
        resultEl.textContent = '';
        statsEl.style.display = 'none';

        const fd = new FormData(form);
        if (!fd.get('region')) fd.delete('region');
        if (!fd.get('pv_kw')) fd.delete('pv_kw');
        if (!fd.get('battery_kwh')) fd.delete('battery_kwh');

        try {
          const res = await fetch('/api/simulate/upload-demand-csv', {
            method: 'POST',
            body: fd,
          });
          if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error + (err.detail ? ' / ' + err.detail : ''));
          }
          const data = await res.json();

          // 統計サマリー
          const stats = [
            ['行数', data.rows.toLocaleString()],
            ['データ間隔', data.interval_minutes + '分'],
            ['年間電力量', data.annual_kwh.toLocaleString() + ' kWh'],
            ['ピーク電力', data.peak_kw + ' kW'],
            ['契約電力 推奨', data.contract_kw_recommendation + ' kW'],
          ];
          if (data.with_pv) {
            stats.push(['PV併設後 契約電力', data.with_pv.contract_kw + ' kW']);
            stats.push(['契約電力削減', data.with_pv.reduction_kw + ' kW']);
          }
          statsEl.innerHTML = stats.map(([k, v]) =>
            `<div class="stat"><div class="stat-label">${k}</div><div class="stat-value">${v}</div></div>`
          ).join('');
          statsEl.style.display = 'grid';

          resultEl.textContent = JSON.stringify(data, null, 2);
        } catch (err) {
          resultEl.textContent = 'ERROR: ' + err.message;
        } finally {
          submitBtn.disabled = false;
          submitBtn.textContent = '解析する';
        }
      });
    